enum LoanRepaymentType {    
    XreolytikoIsoposo = 1,
    XreolytikoAnisoposo = 2, // Baloon
    Tokoxreolytiko = 3,
}

export default LoanRepaymentType;